import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import type { ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription$key } from './__generated__/ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription.graphql';
import { AsyncEditableVersionSummaryDescription as EditableSummaryDescription } from './editable-version-summary-description/async.tsx';
import messages from './messages.tsx';

export const VersionSummaryDescription = ({
	jiraVersion,
}: {
	jiraVersion: ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription$key;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const version = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription on JiraVersion {
				...async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription
			}
		`,
		jiraVersion,
	);

	return (
		<Container>
			<Box xcss={headingStyles} as="h2">
				{formatMessage(messages.descriptionHeader)}
			</Box>
			<DescriptionContainer data-testid="software-releases-version-summary-description.ui.description-container">
				<Box xcss={inlinedEditOffsetStyles}>
					<EditableSummaryDescription jiraVersion={version} shouldTruncateText />
				</Box>
			</DescriptionContainer>
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
});

const inlinedEditOffsetStyles = xcss({
	marginTop: 'space.negative.100',
	marginLeft: 'space.negative.100',
});

const headingStyles = xcss({
	color: 'color.text.subtle',
	font: 'font.body.small',
	fontWeight: 'font.weight.bold',
});
